import type React from "react";
import type { OnStateChange } from "@/components/mosaic/ui/TileTitle/TileTitle";
import { isEnabledAdvancedChart } from "@/lib/utils/features";
import { type ChartState, ChartTypes } from "../types";
import { AdvancedChart } from "./AdvancedChart/AdvancedChart";
import { LightweightChart } from "./LightweightChart/LightweightChart";

export type ChartProps = {
	state: ChartState;
	onStateChange?: OnStateChange;
};

export const Chart: React.FC<ChartProps> = ({ state, onStateChange }) => {
	const isAdvanced =
		(state?.type ?? ChartTypes.ADVANCED) === ChartTypes.ADVANCED;

	return (
		<>
			{isEnabledAdvancedChart() && isAdvanced ? (
				<AdvancedChart state={state} onStateChange={onStateChange} />
			) : (
				<LightweightChart state={state} />
			)}
		</>
	);
};
